const isValidName = (name) => !/[!@#$%&=_~<>?:1234567890]/.test(name) &&
    name.length <= 300 &&
    name.length > 0;
const isValidPhone = (phone) => /^\+?[0-9]([-\s]?\d)*$/.test(phone) &&
    phone.length >= 8 &&
    phone.length <= 30;
const isValidEmail = (email) => /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(email) &&
    email.length <= 300;
const isValidCountry = (country, countryList) => {
    if (!country || !Array.isArray(countryList)) {
        return false;
    }
    return countryList.includes(country);
};
export { isValidEmail, isValidName, isValidPhone, isValidCountry };
